import { render, staticRenderFns } from "./index_v1.0.vue?vue&type=template&id=d5f097a4&"
import script from "./index_v1.0.vue?vue&type=script&lang=js&"
export * from "./index_v1.0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports